export const DEFAULT_ENTERPRISE = 'E000000';
export const LOG_OUT_URL = process.env.REACT_APP_LOGOUT_URI || '';
export const DEFAULT_SECTION = {
  'users-section': false,
  'roles-section': false
};
